import { XCircleIcon } from "@heroicons/react/24/solid";
const CancelButton = ({
  buttonText = "Cancel",
  type = "button",
  onClick,
  disabled = false,
  className = "",
}) => {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      type={type}
      className={`${
        disabled && "opacity-25"
      } hover:scale-90 transition duration-500 flex px-3 items-center shadow-md text-xs font-semibold text-white justify-center gap-x-2 
      rounded-full  bg-octonary  py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-octonary focus:ring-opacity-70 ${className}`}
    >
      <XCircleIcon className="h-4 w-4 " />
      <div className="-mt-px">{buttonText}</div>
    </button>
  );
};
export default CancelButton;
